import { URGENCIES, DEFAULT_URGENCY } from '@/constants/urgencies';
import { DEFAULT_LEAD_EXPIRATION_HOURS } from '@/constants';
import addUTCTimeZoneDesignator from '@/utils/add-utc-time-zone-designator';
import { createCustomer } from './customer';
import { createMatch } from './match';
import { createJobStatus } from './job-status';

export function createJob (data) {
  return {
    ...data,
    // fix time zones
    time_created: addUTCTimeZoneDesignator(data.time_created),
    matches: data.matches.map(match => createMatch({ match })),
    // To override name, phone & zipcode
    customer: createCustomer({ ...data.customer, ...data.location }),
    // Map Urgency ID to text value
    urgency: URGENCIES[data.urgency || DEFAULT_URGENCY].text,
    status: createJobStatus(data.status),
    // Adds lead duration in miliseconds
    lead_expiration: data.lead_expiration || DEFAULT_LEAD_EXPIRATION_HOURS * 60 * 60 * 1000,
  };
}
